import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex bg-black-50 text-para-s mb-10 md:mb-8 p-4",
  role: "alert"
}
const _hoisted_2 = { class: "mt-1 mr-2" }
const _hoisted_3 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_4 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_5 = {
  key: 1,
  class: "flex bg-black-50 text-para-s mb-10 md:mb-8 p-4",
  role: "alert"
}
const _hoisted_6 = { class: "mt-1 mr-2" }
const _hoisted_7 = { class: "font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _ctx.submit,
    as: "div"
  }, {
    default: _withCtx(() => [
      (_ctx.timeout !== undefined && _ctx.timeout < 4)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_Icon, {
                name: "invalid",
                class: "w-4 h-4"
              })
            ]),
            (_ctx.timeout < 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.labels.tokenExpired), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.labels.tokenAboutToExpire), 1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.tokenMissing)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Icon, {
                name: "invalid",
                class: "w-4 h-4"
              })
            ]),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.labels.tokenMissing), 1)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["onSubmit"]))
}